export default __webpack_public_path__ + "static/media/gable.4e8f1646.png";